<template>
  <el-collapse class="plan-item">
    <el-collapse-item
      v-for="(item, index) in detailedPlan"
      :key="index"
      :title="titles[index] + ' ' + (feeSum(item) / 100) + '元'"
    >
      <div
        v-for="(role, i) in item"
        :key="i"
      >
        <h5 style="text-align: left; margin: 0; padding: 0;">
          {{ role.role_title }}: {{ role.fee / 100 }}元
        </h5>
        <el-tabs>
          <el-tab-pane
            v-for="(orders, j) in role.order"
            :key="j"
            :label="orders.label + ':' + (orders.amount / 10000) + '万元/' + (orders.fee / 100) + '元'"
          >
            <el-table :data="orders.order">
              <el-table-column
                prop="name"
                label="产品"
              />
              <el-table-column
                prop="amount"
                label="保额"
              >
                <template slot-scope="scope">
                  {{ scope.row.amount / 10000 }}万元
                </template>
              </el-table-column>
              <el-table-column
                prop="payment_period"
                label="缴费年限"
              />
              <el-table-column
                prop="period"
                label="保障年限"
              >
                <template slot-scope="scope">
                  {{ scope.row.to_age === -1 ? scope.row.period + '年' : scope.row.to_age + '岁' }}
                </template>
              </el-table-column>
              <el-table-column
                prop="fee"
                label="保费"
              >
                <template slot-scope="scope">
                  {{ scope.row.fee / 100 }}元
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-collapse-item>
  </el-collapse>
</template>
<script>
  import request from "../../../api/request"

  export default {
    name: 'CustomServiceToolsPlan',
    props: {
      userId: {
        type: Number,
        default: 0
      }
    },
    data: function() {
      return {
        titles: [
          '经济支柱-100%-保费最低',
          '经济支柱-100%-精选产品',
          '经济支柱-基础-保费最低',
          '经济支柱-基础-精选产品',
          '非经济支柱-保费最低',
          '非经济支柱-精选产品',
          '全家医疗险-最低保费 价格',
          '全家医疗险-精选产品 价格'
        ],
        plans: [],
        loading: false
      }
    },
    computed: {
      detailedPlan: function () {
        let ret = []
        for(let t of this.plans) {
          let tmp = {}
          for (let p of t['products']) {
            const role = p.role
            if (!tmp[role]) {
              tmp[role] = {
                role: role,
                role_title: p.role_title,
                fee: 0,
                order: {}
              }
            }
            if (!tmp[role].order[p.risk_mask]) {
              tmp[role].order[p.risk_mask] = {
                fee: 0,
                amount: 0,
                label: p.risk_mask === 3 ? '寿险' : p.risk_mask === 65536 ? '重疾' : p.risk_mask === 32768 ? '医疗' : '意外',
                order:[]
              }
            }
            tmp[role].fee += p.fee
            tmp[role].order[p.risk_mask].fee += p.fee
            tmp[role].order[p.risk_mask].amount += p.amount
            tmp[role].order[p.risk_mask].order.push(p)
          }
          ret.push(tmp)
        }

        return ret
      }
    },
    watch: {
      userId: function () {
        this.getAdminPlans()
      }
    },
    created: function () {
      this.getAdminPlans()
    },
    methods: {
      getAdminPlans: function () {
        if (!this.userId) {
          return
        }
        this.loading = true
        request.front.post('user_get_admin_plans', {
          user_id: this.userId
        }).then(resp => {
          this.plans = resp.data
          this.loading = false
        })
      },
      feeSum: function(item) {
        let fee = 0
        Object.values(item).map(role => {
          fee += role.fee
        })
        return fee
      }
    }
  }
</script>
<style>
  .plan-item .el-collapse-item__header {
    background: #2c3e50;
    color: #FFF;
    padding: 0 0 0 5px;
  }
</style>